<template>

    <div>

        <MarginInput :options="options"
            :open="open"
        />

        <ColorsInput label="Achtergrondkleur"
                     instruction="Bepaal hier de achtergrondkleur van het gehele blok."
                     :colors="colors"
                     :options="options"
                     options-property="color"
        />

        <ColorsInput label="Tekstkleur"
                     instruction="Bepaal hier de tekstkleur van het gehele blok."
                     :colors="colors"
                     :options="options"
                     options-property="textColor"
        />

        <AnchorInput :options="options"/>

    </div>

</template>

<script>

import AnchorInput from "./AnchorInput";
import MarginInput from "./MarginInput";
import ColorsInput from "./ColorsInput";
import axios from "@galaxy/modules/Core/resources/js/axiosBuilder";
import {HalfCircleSpinner} from 'epic-spinners';
import getDatabaseColors from "../../../../../components/canvas/blocks/utils/text/admin/getDatabaseColors";

// TODO Concord: Load in by default? Now no blocks loads it in?
export default {

    components: {
        ColorsInput,
        AnchorInput,
        MarginInput,
        HalfCircleSpinner,
    },

    props: {
        options: Object,
        open: {
            type: Boolean,
            default: true,
        }
    },

    data: function () {
        return {
            colors: null,
        }
    },

    mounted() {
        this.loadColors();
    },

    methods: {

        async loadColors() {
            // Grab database colors
            let databaseColors = (await getDatabaseColors(true)).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);

            let formattedColors = {};

            for (const color of this.colors) {
                if (typeof color === 'object') {
                    for (const [key, value] of Object.entries(color)) {
                        formattedColors[key] = value;
                    }
                } else {
                    formattedColors[color] = color;
                }
            }

            this.colors = formattedColors;
        },

    },

}
</script>
